import React from 'react';
import Axios from 'axios';
import moment from 'moment';

class RateSysAdminParams extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    	nbPlayers: 0,
    	nbFormEntries: 0,
			rateSysDivOption: false,
			playersByDivision: false,
			committeeVotes: false,
			elTrophyVotes: false,
			showAdvancedStats: false,
			ratingActive: false
		};
		
		this.handleSaveParams = this.handleSaveParams.bind(this);
		this.handleCompileResultsClick = this.handleCompileResultsClick.bind(this);
		this.handlePlayersByDivisionCheckbox = this.handlePlayersByDivisionCheckbox.bind(this);
		this.handleCommitteeVotesCheckbox = this.handleCommitteeVotesCheckbox.bind(this);
		this.handleElTrophyVotesCheckbox = this.handleElTrophyVotesCheckbox.bind(this);
		this.handleShowAdvancedStatsCheckbox = this.handleShowAdvancedStatsCheckbox.bind(this);
		this.handleRatingActiveCheckbox = this.handleRatingActiveCheckbox.bind(this);
		this.handleImportPlayersClick = this.handleImportPlayersClick.bind(this);
	}

  componentDidMount() {
		//console.log('RateSysAdminParams: componentDidMount');
		this.loadData();
	}

  componentDidUpdate(prevProps) {
  	//console.log('RateSysAdminParams: componentDidUpdate')
  	if (this.props.season._id !== prevProps.season._id) {
			this.loadData();
	  }
  }

	loadData() {
  	//console.log('RateSysAdminParams: loadData')
		if (this.props.season._id !== undefined) {
	    Axios.get('/api/ratesys/getRateSys/global/' + this.props.season._id).then(responseRateSys => {
    	Axios.get('/api/ratesys/nbRespondents/seasonId/' + this.props.season._id + '/division/ALL').then(responseNbResp => {

  	  	// Rating System Divisions check
  	  	var rateSysDivOption = false;
  	  	if (this.props.season.subSeasons[0].divisions.length > 1) {
  	  		rateSysDivOption = true;
  	  	}

	    	var rateSys = responseRateSys.data;
				this.setState({
					nbPlayers: rateSys.players.length,
					nbFormEntries: responseNbResp.data.rateSysNbRespondents,	// ALL div here
					rateSysDivOption: rateSysDivOption,
					playersByDivision: rateSys.playersByDivision,
					committeeVotes: rateSys.committeeVotes,
					elTrophyVotes: rateSys.elTrophyVotes,
					showAdvancedStats: rateSys.showAdvancedStats,
					ratingActive: rateSys.ratingActive
				});
			});		
			});		
	  }
	}

	render() {
		// console.log('RateSysAdminParams: render');
		// console.log(this.props);

    return (
      <div>

      <div className="row">
      <div className="col-md-12">
      	<h5>Stats</h5>
      </div>
      </div>

      <div className="row">
	    <div className="row col-md-12 col-xs-12">
				<ul>
					<li>Nombre de joueurs: {this.state.nbPlayers}</li>
					<li>Nombre de formulaires: {this.state.nbFormEntries}</li>
			</ul>
      </div>
      </div>
      <hr/>

      <div className="row">
      <div className="col-md-12">
      	<h5>Paramètres</h5>
      </div>
      </div>

			<div className="row row-margin-bottom-10">
	      {this.state.rateSysDivOption ? 
				<div className="col-md-3 col-12">
					<h6>Divisions</h6>
					<p>Cette saison contient des divisions dans la première sous-saison, cocher la case pour séparer les joueurs par division.</p>

					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.playersByDivision || false} onChange={this.handlePlayersByDivisionCheckbox}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Joueurs par division

        </div>
        : null}

				<div className="col-md-3 col-12">
					<h6>Comité</h6>
					<p>Activer cette option pour afficher une section "Votes de Comité" dans le formulaire de cotation.</p>

					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.committeeVotes || false} onChange={this.handleCommitteeVotesCheckbox}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Votes de comité
        </div>

				<div className="col-md-3 col-12">
					<h6>Trophée Éric Lavoie</h6>
					<p>Activer cette option pour afficher une section "Votes pour le Trophée Éric Lavoie" dans le formulaire de cotation.</p>

					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.elTrophyVotes || false} onChange={this.handleElTrophyVotesCheckbox}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Votes pour le Trophée Éric Lavoie
        </div>

				<div className="col-md-3 col-12">
					<h6>Stats avancées</h6>
					<p>Activer cette option pour afficher les stats avancées (informations sensibles!)</p>

					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.showAdvancedStats || false} onChange={this.handleShowAdvancedStatsCheckbox}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Stats avancées
        </div>      

				<div className="col-md-3 col-12">
					<h6>Cotation Active</h6>
					<p>Activer cette option pour Activer l'acceptation des formulaires (ou l'inverse)</p>

					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.ratingActive || false} onChange={this.handleRatingActiveCheckbox}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;Cotation active
        </div>     
       </div>

			<div className="row">
			<div className="col-md-12">
				<button type="button" className="btn btn-primary" onClick={this.handleSaveParams}>
					Sauvegarder les paramètres</button>
    	</div>
    	</div>
      <hr/>

      <div className="row">
      <div className="col-md-12">
      	<h5>Actions</h5>
      </div>
      </div>

	    <div className="row">
			<div className="col-md-12">
				<button type="button" className="btn btn-primary width175px btn-margin-right-20" onClick={this.handleImportPlayersClick}>
					Importer les joueurs</button>
				<p>Doit être fait lors de la création du système de cotation (détruit l'ancienne liste de joueurs)</p>
    	</div>
    	</div>
    	<br/>

			<div className="row">
			<div className="col-md-12">
				<button type="button" className="btn btn-primary width175px" onClick={this.handleCompileResultsClick}>
					Compiler les résultats</button>
				<p>Déjà fait lorsqu'un formulaire est soumis</p>
    	</div>
    	</div>

      <hr/>


      </div>
	  );
  }

  handlePlayersByDivisionCheckbox(e) {
		this.setState({
			playersByDivision: e.target.checked
		});
  }
  handleCommitteeVotesCheckbox(e) {
		this.setState({
			committeeVotes: e.target.checked
		});
  }
  handleElTrophyVotesCheckbox(e) {
		this.setState({
			elTrophyVotes: e.target.checked
		});
  }
  handleShowAdvancedStatsCheckbox(e) {
		this.setState({
			showAdvancedStats: e.target.checked
		});
  }
  handleRatingActiveCheckbox(e) {
		this.setState({
			ratingActive: e.target.checked
		});
  }

	handleSaveParams() {
		//console.log('handleSaveParams');
		var params = {
			playersByDivision: this.state.playersByDivision,
			committeeVotes: this.state.committeeVotes,
			elTrophyVotes: this.state.elTrophyVotes,
			showAdvancedStats: this.state.showAdvancedStats,
			ratingActive: this.state.ratingActive
		};

		Axios.post('/api/rateSys/setParams/', {
			seasonId: this.props.season._id,
			params: params
		})
		.then(response => {

		})
		.catch(error => {
			console.log('error');
			console.log(error);
		});
  }

	handleImportPlayersClick() {
		//console.log('handleImportPlayersClick');
		Axios.post('/api/rateSys/importPlayers/', {
			seasonId: this.props.season._id,
		})
		.then(response => {
			this.loadData()
		})
		.catch(error => {
			console.log('error');
			console.log(error);
		});
  }

	handleCompileResultsClick() {
		//console.log('handleCompileResultsClick');
		Axios.post('/api/rateSys/compileResults/', {
			seasonId: this.props.season._id,
		})
		.then(response => {
			/*
			if (response.data.msg === "OK") {
				alert("Système de cotation créé avec succès")
				this.props.reloadSeason();
			}
			if (response.data.msg === "xxxxxx") {
				alert("Système de cotation déjà existant pour cette saison")
			}
			*/
		})
		.catch(error => {
			console.log('error');
			console.log(error);
		});
  }

}

export default RateSysAdminParams;